import React, { Fragment, useCallback } from "react";
import { View, Text, FlatList } from "react-native";
import ResponsiveContent from "../shared/responsive-content";
import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import useResponsiveWidth from "@/elements/hooks/use-responsive-width";
import ParentChatListItem from "./parent-chat-list-item";
import ParentChatEmptyState from "./parent-chat-empty-state";
import Loader from "../shared/loader";

function ParentChatList() {
  const { data: chats = [], isLoading } = useQuery(
    convexQuery(api.parent.inbox.queries.getChats, {})
  );
  const dataLength = chats.length;
  const responsiveWidth = useResponsiveWidth();

  const renderItem = useCallback(
    ({
      item,
    }: {
      item: (typeof api.parent.inbox.queries.getChats._returnType)[number];
    }) => {
      return <ParentChatListItem chat={item} />;
    },
    []
  );

  const ListEmptyComponent = useCallback(() => {
    return isLoading ? <Loader /> : <ParentChatEmptyState />;
  }, [isLoading]);

  const ListFooterComponent = useCallback(() => {
    return (
      <Fragment>
        {dataLength > 0 && <View className="h-[1px] bg-gray-200" />}
        <View className="h-[75px]" />
      </Fragment>
    );
  }, [dataLength]);

  const ListHeaderComponent = useCallback(() => {
    return (
      <Fragment>
        {dataLength > 0 && <View className="h-[1px] bg-gray-200" />}
      </Fragment>
    );
  }, [dataLength]);

  const ItemSeparatorComponent = useCallback(() => {
    return <View className="h-[1px] bg-gray-200" />;
  }, []);

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <ResponsiveContent>
        <View className="h-3" />
        <View className="mx-5">
          <View className="gap-1">
            <Text className="font-zilla-slab-medium font-medium text-dark text-[28px] leading-[1.2]">
              Chats
            </Text>
            <Text className="font-geologica-regular font-normal text-[20px] text-gray-800 leading-[1.5]">
              Connect with your child&apos;s tutors to share information and
              updates.
            </Text>
          </View>
        </View>
        <View className="h-8" />
      </ResponsiveContent>
      <FlatList
        data={chats}
        renderItem={renderItem}
        ItemSeparatorComponent={ItemSeparatorComponent}
        ListEmptyComponent={ListEmptyComponent}
        contentContainerStyle={
          chats.length === 0
            ? { justifyContent: "center", flex: 1 }
            : {
                width: responsiveWidth,
                alignSelf: "center",
              }
        }
        ListFooterComponent={ListFooterComponent}
        ListHeaderComponent={ListHeaderComponent}
      />
    </View>
  );
}

export default ParentChatList;
